import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../contexto/ContextoDatos';
import styles from './QuickViewModal.module.css';

export const QuickViewModal = () => {
  const { quickViewProduct, setQuickViewProduct } = useContext(DataContext);
  const [imgError, setImgError] = useState(false);
  const navigate = useNavigate();

  // Reset img error when product changes
  useEffect(() => {
    setImgError(false);
  }, [quickViewProduct]);

  // Lock scroll when modal is open
  useEffect(() => {
    if (quickViewProduct) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [quickViewProduct]);

  if (!quickViewProduct) return null;

  const handleClose = () => setQuickViewProduct(null);

  const imgSrc = `/imagenes/productos/${quickViewProduct.slug}-1.webp`;
  
  const whatsappMsg = `Hola SEIMA, me interesa solicitar una cotización sobre ${quickViewProduct.name}${quickViewProduct.model ? ` (Modelo: ${quickViewProduct.model})` : ''}.`;
  const whatsappUrl = `https://wa.me/50230978165?text=${encodeURIComponent(whatsappMsg)}`;

  const handleGoToProduct = () => {
    handleClose();
    navigate(`/productos/${quickViewProduct.slug}`);
  };

  const handleContactForm = () => {
    handleClose();
    navigate(`/productos/${quickViewProduct.slug}#contact`);
  };

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={handleClose} aria-label="Cerrar vista rápida">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="24" height="24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className={styles.modalGrid}>
          {/* Left: Image */}
          <div className={styles.imageArea}>
            {!imgError ? (
              <img 
                src={imgSrc} 
                alt={quickViewProduct.name} 
                className={styles.productImage}
                onError={() => setImgError(true)}
              />
            ) : (
              <div className={styles.placeholder}>
                <span>Sin imagen</span>
              </div>
            )}
            <div className={styles.badges}>
              {quickViewProduct.best_seller && <span className={styles.badge}>BEST SELLER</span>}
              {quickViewProduct.on_demand && <span className={styles.badgeBajoPedido}>BAJO PEDIDO</span>}
            </div>
          </div>

          {/* Right: Info */}
          <div className={styles.infoArea}>
            <p className={styles.brand}>{quickViewProduct.brand || 'SEIMA'}</p>
            <h2 className={styles.title}>{quickViewProduct.name}</h2>
            {quickViewProduct.model && (
              <p className={styles.model}>Modelo: <strong>{quickViewProduct.model}</strong></p>
            )}
            
            <div className={styles.divider} />

            <div className={styles.specs}>
              {quickViewProduct.use && (
                <div className={styles.specRow}>
                  <span className={styles.specLabel}>Aplicación:</span>
                  <span className={styles.specValue}>{quickViewProduct.use}</span>
                </div>
              )}
              {quickViewProduct.category && (
                <div className={styles.specRow}>
                  <span className={styles.specLabel}>Categoría:</span>
                  <span className={styles.specValue}>{quickViewProduct.category}</span>
                </div>
              )}
            </div>

            <p className={styles.description}>
              {quickViewProduct.description || "Contáctenos para obtener especificaciones técnicas detalladas y ficha técnica oficial de este equipo."}
            </p>

            <div className={styles.actions}>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={`btn btn-primary ${styles.btnWhatsapp}`}>
                <svg fill="currentColor" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Cotizar en WhatsApp
              </a>
              <button onClick={handleContactForm} className={`btn btn-secondary ${styles.btnForm}`}>
                Contactar por Correo
              </button>
            </div>

            <button onClick={handleGoToProduct} className={styles.linkToProduct}>
              Ver página completa del producto →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuickViewModal;
